// extracted by mini-css-extract-plugin
export var inputContainer = "_o5-0";